import { Component, OnInit } from '@angular/core';
import { CovidService} from '../../covid.service';
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { References } from '../../interfaces/references';
import { Countries } from '../../interfaces/countries';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.less'],
})
export class ArticlesComponent implements OnInit {
  searchForm = new FormGroup({
    query: new FormControl('', Validators.required),
    filterby: new FormControl('', Validators.required)
  });
  text = null;
  loading = false;
  query = '';
  filters = [{
    name: 'Author',
    placeholder: 'Ex: Dunjin, Chen'
  }, {
    name: 'Abstract',
    placeholder: 'Ex: SARS-CoV-2 China pneumonia'
  }, {
    name: 'Title',
    placeholder: 'Ex: Coronavirus infections and immune responses'
  }];
  filterBy = this.filters[0];
  references = null;
  total = null;
  page = 1;
  itemsPerPage = null;
  nextPage = null;
  totalPages = null;
  currentSearch = null;
  worldCountries = null;
  foundResults = null;
  constructor(private covid: CovidService) { }

  ngOnInit(): void {
    this.doSearch('All');
  }

  doSearch(search) {
    this.loading = true;
    this.query = this.searchForm.value.query;

    if (this.currentSearch !== search) {
      this.resetSearch();
    }

    switch (search) {
      case 'All':
        this.searchAll();
        break;
      case 'Title':
        this.searchByTitle();
        break;
      case 'Author':
        this.searchByAuthor();
        break;
      case 'Abstract':
        this.searchByAbstract();
        break;
    }

    this.currentSearch = search;
  }

  selectedOption($event) {
    this.text = $event.value;
    this.filterBy = $event.value.name;
  }

  searchByCategory({category, uid}) {
    this.loading = true;
    this.resetSearch();

    if (uid) {
      this.currentSearch = category;
      this.covid.searchByCategory(uid, this.page)
      .subscribe(this.setReferencesData.bind(this));
    } else {
      this.searchAll();
    }
  }

  searchByCountry(country) {
    this.loading = true;
    this.resetSearch();
    this.currentSearch = country;
    this.covid.searchByCountry(country, this.page)
    .subscribe(this.setReferencesData.bind(this));
  }

  searchByAuthor() {
    this.covid.searchByAuthor(this.query, this.page)
    .subscribe(this.setReferencesData.bind(this));
  }

  searchByTitle() {
    this.covid.searchByTitle(this.query, this.page)
    .subscribe(this.setReferencesData.bind(this));
  }

  searchByAbstract() {
    this.covid.searchByAbstract(this.query, this.page)
    .subscribe(this.setReferencesData.bind(this));
  }

  searchAll() {
    this.currentSearch = 'All';
    this.covid.searchAll(this.page)
    .subscribe(this.setReferencesData.bind(this));
  }

  setReferencesData({total, items_per_page, page, next_page, total_pages, items}: References) {
    this.foundResults = total ? true : false;
    this.total = total ? total : null;
    this.itemsPerPage = items_per_page ? items_per_page : null;
    this.page = page ? page : 1;
    this.nextPage = next_page ? next_page : null;
    this.totalPages = total_pages ? total_pages : null;
    this.references = items.length ? items.map((item) => this.covid.getLiteAbstract(item)) : null;
    this.loading = false;
  }

  clearQuery(form: FormGroup) {
    form.reset({query: ''});
    form.controls.query.setErrors(null);
  }

  moreData({pageIndex}) {
    this.page = pageIndex;
    this.doSearch(this.currentSearch);
  }

  resetSearch() {
    this.page = 1;
  }
}
